export const BRAND = {
  productName: 'XpansVault',
  companyName: 'Xpanstech Solutions Private Limited',
  companyShort: 'Xpanstech Solutions',
  tagline: 'Secure document vaults for organizations',
  copyright: `© ${new Date().getFullYear()} Xpanstech Solutions Private Limited`,
  poweredBy: 'A product of Xpanstech Solutions Private Limited',
  pageTitle: 'XpansVault | Xpanstech Solutions',
  metaDescription:
    'XpansVault — multi-organization document vaults with company admins, sharing, storage plans, MFA, and audit controls by Xpanstech Solutions.',
  logo: '/xpansvault-logo.png',
  icon: '/xpansvault-icon.svg'
}

export default BRAND
